import {
    FETCH_USER_CONSENTS,
    FETCH_USER_CONSENTS_SUCCESS,
    FETCH_USER_CONSENTS_FAILED
  } from "../store/types";
  
  const initialState = {
    consents: [],
    loading: false,
    error: null
  };
  
  export default function consentsReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_USER_CONSENTS:
        return {
          ...state,
          loading: true,
          error: null
        };
      case FETCH_USER_CONSENTS_SUCCESS:
        return {
          ...state,
          consents: action.payload,
          loading: false,
          error: null
        };
      case FETCH_USER_CONSENTS_FAILED:
        return {
          ...state,
          consents: [],
          loading: false,
          error: action.payload
        };
      default:
        return state;
    }
  }
  